(function() {
    angular.module('invesfleet')
        .directive('checkboxstatus', function() {
            //TRUE:checked='true' | FALSE:checked='false' | NULL:indeterminate='true'
            return {
                restrict: 'A',
                link: function(scope, element, attributes) {
                    scope.$watch(attributes['checkboxstatus'], function (value) {
                        if(value == null){
                            element[0].indeterminate = true;
                        }else{
                            element[0].indeterminate = false;
                            element[0].checked = value;
                        }
                    });
                }
            };
        });
}());